module.exports = __webpack_public_path__ + "static/img/10.ff7655f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/sp/10.png
// module id = dDxp
// module chunks = 0